import React, { useState, useEffect } from 'react';
import SeccionDelegacion from '../../../UsuariosAdmin/components/SeccionDelegacion';

export const TabDelegacion = ({
    allowedWrite,
    isNew,
    profesionalLoading,
    delegacionFormData,
    delegacionesUsuario,
    setDelegacionFormData
}) => {
    const [delegacionMonitoreo, setDelegacionMonitoreo] = useState(delegacionFormData?.idDelegacionMonitoreo || 0);
    const [delegacionesSeleccionadas, setDelegacionesSeleccionadas] = useState(delegacionFormData?.delegaciones || []);
    const [delegaciones, setDelegaciones] = useState([]);
    const [regionesOptions, setRegionesOptions] = useState([]);

    useEffect(() => {
        setDelegacionFormData({
            ...delegacionFormData,
            idDelegacionMonitoreo: delegacionMonitoreo,
            delegaciones: delegacionesSeleccionadas
        });
    }, [delegacionMonitoreo, delegacionesSeleccionadas]);

    return (
        <SeccionDelegacion
            regiones={regionesOptions}
            setRegiones={setRegionesOptions}
            delegaciones={delegaciones}
            setDelegaciones={setDelegaciones}
            delegacionesSeleccionadas={delegacionesSeleccionadas}
            setDelegacionesSeleccionadas={setDelegacionesSeleccionadas}
            delegacionOrigen={delegacionMonitoreo}
            setDelegacionOrigen={setDelegacionMonitoreo}
            textoDelegacionOrigen="Delegación de Monitoreo"
            delegacionesUsuario={delegacionesUsuario}
            isFromGestionProfesional
        />
    );
}